import type { CondensateViscosityParameters } from "../../d";

// returns mu_od cP
export function deadCondensateViscosityCalculator(
  params: CondensateViscosityParameters
): {
  x: number;
  deadCondensateViscosity: number;
} {
  const { temperatureF, condensateSpecificGravity } = params;

  // PVT!BJ54: =(D18^(-1.163))*EXP((13.108-6.591/AW25))
  const x =
    temperatureF ** -1.163 *
    Math.exp(13.108 - 6.591 / condensateSpecificGravity);

  // PVT!BJ56: =(10^(BJ54))-1
  const deadCondensateViscosity = 10 ** x - 1;

  return {
    x,
    deadCondensateViscosity
  };
}
